import { useCallback, useState } from "react";
export function useDebounceClick(delay = 300) {
    const [canClick, setCanClick] = useState(true);
    const debounceClick = useCallback((callback) => {
        if (!canClick)
            return;
        setCanClick(false);
        callback();
        setTimeout(() => {
            setCanClick(true);
        }, delay);
    }, [canClick, delay]);
    return { debounceClick, canClick };
}
//# sourceMappingURL=useDebounceClick.js.map